export default "__VITE_PUBLIC_ASSET__23cb9622__"